import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Header,
  Form,
  Loader,
  Label,
} from 'semantic-ui-react';
import {
  DatesRangeInput
} from 'semantic-ui-calendar-react-17';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/pt-br';
import _ from 'lodash';
import { PaginationContainer } from '../../components/PaginationContainer';
import { activityActions } from '../../actions/activity.actions';
import { durationFromSeconds } from '../../helpers/timeFormat';

const DATE_FORMAT = "DD/MM/YYYY";
const FILTER_FORMAT = "YYYY-MM-DD";

class UserActivityScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      username: '',
      computerName: '',
      application: '',
      period: '',
    };
  }

  static get propTypes() {
    return {
      registers: PropTypes.any,
      loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    this.handleSearchDebounced = _.debounce(function () {
      this.fetchRegisters();
    }, 500);

    // Pre-fill the user filter when arriving from the dashboard ranking (?username=...).
    const search = this.props.location ? this.props.location.search : '';
    const username = new URLSearchParams(search).get('username') || '';

    const start = moment().startOf('month').format(DATE_FORMAT);
    const end = moment().endOf('month').format(DATE_FORMAT);
    this.setState({ username, period: `${start} - ${end}` }, () => this.fetchRegisters());
  }

  handlePageChange(activePage) {
    this.setState({ page: activePage }, () => this.fetchRegisters());
  }

  handlePeriodChange(period) {
    this.setState({ period, page: 1 }, () => this.fetchRegisters());
  }

  handleChange(field, value) {
    this.setState({ [field]: value, page: 1 });
    this.handleSearchDebounced();
  }

  fetchRegisters() {
    const { dispatch } = this.props;
    const { page, username, computerName, application, period } = this.state;

    var [startDate, endDate] = period.split(' - ');
    if (startDate) {
      startDate = moment(startDate, DATE_FORMAT).format(FILTER_FORMAT);
    }
    if (endDate) {
      endDate = moment(endDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    dispatch(activityActions.fetch({
      page,
      username: username || null,
      computerName: computerName || null,
      application: application || null,
      startDate,
      endDate,
      orderBy: "PeriodStart",
      ascending: false,
    }));
  }

  render() {
    const { registers, loading } = this.props;
    const { period, username } = this.state;

    return (
      <Fragment>
        <Header>
          <h1>Atividade de Aplicativos</h1>
        </Header>
        <Loader active={loading} />
        <Form>
          <Form.Group>
            <DatesRangeInput
              name="period"
              localization="pt-br"
              placeholder="Período"
              value={period}
              iconPosition="left"
              dateFormat={DATE_FORMAT}
              label='Período'
              closable={true}
              clearable={true}
              onChange={(e, data) => this.handlePeriodChange(data.value)}
            />
            <Form.Input icon='search' label='Usuário' value={username} onChange={(e, data) => this.handleChange("username", data.value)} loading={loading} />
            <Form.Input icon='desktop' label='Máquina' onChange={(e, data) => this.handleChange("computerName", data.value)} loading={loading} />
            <Form.Input icon='window maximize outline' label='Aplicativo' onChange={(e, data) => this.handleChange("application", data.value)} loading={loading} />
          </Form.Group>
        </Form>

        {registers && registers.Results && registers.Results.length > 0 &&
          <Table compact>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Início</Table.HeaderCell>
                <Table.HeaderCell>Usuário</Table.HeaderCell>
                <Table.HeaderCell>Máquina</Table.HeaderCell>
                <Table.HeaderCell>Aplicativo</Table.HeaderCell>
                <Table.HeaderCell textAlign='right'>Tempo Ativo</Table.HeaderCell>
                <Table.HeaderCell textAlign='right'>Tempo Ocioso</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              { registers.Results.map((register) => {
                return <Table.Row key={register.Id}>
                  <Table.Cell>{register.PeriodStart ? moment(register.PeriodStart).format('DD/MM/YYYY HH:mm') : '-'}</Table.Cell>
                  <Table.Cell>{register.UserAccount}</Table.Cell>
                  <Table.Cell>{register.ComputerName ?? '-'}</Table.Cell>
                  <Table.Cell>
                    {register.Application}
                    {register.Title ? <Label size='mini' style={{ marginLeft: '6px' }}>{register.Title}</Label> : null}
                  </Table.Cell>
                  <Table.Cell textAlign='right'>{durationFromSeconds(register.ActiveSeconds)}</Table.Cell>
                  <Table.Cell textAlign='right'>{durationFromSeconds(register.IdleSeconds)}</Table.Cell>
                </Table.Row>;
              }) }
            </Table.Body>
          </Table>}

        {registers && registers.Results && registers.Results.length == 0 &&
          <p>Nenhuma atividade encontrada para os filtros selecionados.</p>}

        <PaginationContainer registers={registers} onPageChange={(e, { activePage }) => this.handlePageChange(activePage)} />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { activity } = state;

  return {
    registers: activity?.list || null,
    loading: activity?.loading,
  };
}

const connectedUserActivityScreen = connect(mapStateToProps)(UserActivityScreen);
export { connectedUserActivityScreen as UserActivityScreen };
